'use es6';

import { Map as ImmutableMap } from 'immutable';
import ActionTypes from '../actions/ActionTypes';
const INITIAL_STATE = ImmutableMap({
  data: null,
  hasError: false,
  recentError: null,
  isRequesting: false,
  hasFetchedOnce: false
});
export default function Accounts(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ActionTypes.ACCOUNTS_REQUESTING:
      return state.merge({
        isRequesting: true,
        hasError: false,
        hasFetchedOnce: true
      });

    case ActionTypes.ACCOUNTS_RECEIVED:
      return state.merge({
        isRequesting: false,
        hasError: false,
        data: action.payload.get('accounts')
      });

    case ActionTypes.ACCOUNTS_ERROR:
      return state.merge({
        isRequesting: false,
        hasError: true,
        recentError: action.payload
      });

    default:
      return state;
  }
}